/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { LogoutService } from '../../../../core/security/components/logout/logout.service';

export class LogoutCommand extends MapCommand {

    private logoutService: LogoutService;

    invoke() {
        this.logoutService.doLogout();
    }

    protected onCommandInit() {
        super.onCommandInit();
        this.logoutService = this.deps['logoutService'];
    }
}
